<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-dialog
        v-model="dialog"
        persistent :overlay="false"
        transition="dialog-transition"
        max-width="400px"
      >
        <v-card>
          <v-card-text class="text-xs-center">
            <v-progress-circular :indeterminate="true" size="80" color="blue" v-if="problem==null" class="mt-5 mb-2"></v-progress-circular>
            <h3 class="mt-5 mb-3" v-if="problem==null">{{aktualni_stav}}</h3>
            <h3 v-else class="mb-3 mt-3 red--text">{{problem}}</h3>
            <v-btn color="grey" class="mt-3" flat @click="dialog=false" v-if="problem!=null">Zavřít</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <v-form v-else lazy-validation ref="form" v-model="valid">
          <div class="gui-flex gui-flex-rows">
            <div class="custom-scrollbar">
              <h2 class="mx-2"><span v-if="!objednavka.pouze_naskladnit">Faktura</span><span v-else>Naskladnění</span> k obj. č. {{objednavka.cislo_objednavky}}</h2>
              <v-card class="no__radius grey lighten-4 mt-3">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm4 md3 lg2 v-if="!pouze_naskladnit">
                      <v-text-field
                        label="Číslo faktury dodavatele"
                        class="mx-3"
                        v-model="fa_cislo"
                        :rules="rulesRequired"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md3 lg2>
                      <datepicker label="Datum vystavení fa dodavatele" v-model="fa_datum_vystaveni" :rules="true" class="mx-3"></datepicker>
                    </v-flex>
                    <v-flex xs12 sm4 md3 lg2>
                      <meny v-model="mena_id" @changed="(e) => { this.mena = e; }" all class="mx-3"></meny>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-card class="no__radius grey lighten-4 mt-3">
                <v-card-text>
                  <v-data-table
                    :headers="produktyHeaders"
                    :items="objednavka.produkty"
                    hide-actions
                    class="mx-2 mt-3"
                    color="transparent"
                  >
                    <template slot="items" slot-scope="props">
                      <td>
                        <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank" v-if="props.item.typ=='produkt'">
                          {{ props.item.produkt.nazev }}
                        </router-link>
                        <span v-else><span v-if="!dodavatel.metal_konto">Interní </span>Metal konto - {{props.item.material.nazev}}</span>
                      </td>
                      <td class="text-xs-right">
                        <span v-if="props.item.typ=='produkt'">{{props.item.mnozstvi}} ks</span>
                        <span v-else>{{props.item.mnozstvi | formatMoney}} g</span>
                      </td>
                      <td>
                        <v-text-field v-if="(props.item.typ=='produkt' || !pouze_naskladnit) && props.item.mnozstvi > 0" reverse class="right" style="max-width: 150px" :suffix="mena.zkratka" @input="changeMJ(props.item)" v-model="props.item.cena_mj" :rules="rulesRequired"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-if="(props.item.typ=='produkt' || !pouze_naskladnit) && props.item.mnozstvi > 0" reverse class="right" style="max-width: 150px" :suffix="mena.zkratka" @input="changeCelk(props.item)" v-model="props.item.cena_celkem" :rules="rulesRequired"></v-text-field>
                      </td>
                    </template>
                    <template slot="footer" v-if="!objednavka.pouze_naskladnit">
                      <tr>
                        <td colspan="3"><strong>Celková částka:</strong></td>
                        <td>
                          <div class="mt-4 mb-4 text-xs-right">
                            <strong>{{total | formatMoney}} {{mena.zkratka}}</strong>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-card class="no__radius grey lighten-4 mt-3" v-if="!pouze_naskladnit">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="mr-4 pr-2">
                        <v-text-field reverse class="" style="max-width: 250px" :suffix="mena.zkratka" v-model="cena_dopravy" label="Cena dopravy" class="right"></v-text-field>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-layout row wrap class="mt-5">
                <v-flex xs12 class="mx-2">
                  <v-btn color="green" v-if="!pouze_naskladnit" depressed large dark @click="ulozitFakturu" class="right" :loading="saving">Uložit fakturu</v-btn>
                  <v-btn color="green" v-else depressed large dark @click="ulozitFakturu" class="right" :loading="saving"><span v-if="!faktura">Naskladnit</span><span v-else>Uložit</span></v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      produktyHeaders: [
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false, width: "300px" },
        { text: 'Množství', value: 'mnozstvi', sortable: false, width: "180px", align: "right" },
        { text: 'Nákupní cena za MJ', value: 'nakupni_cena_mj', sortable: false, width: "180px", align: "right" },
        { text: 'Nákupní cena celková', value: 'nakupni_cena_celkem', sortable: false, width: "180px", align: "right" }
      ],
      objednavka: null,
      faktura: null,
      fa_cislo: null,
      fa_datum_vystaveni: null,
      mena_id: null,
      mena: null,
      valid: false,
      rulesRequired: [ (v) => v != null || "Pole je vyžadováno" ],
      cena_dopravy: null,
      problem: null,
      dialog: false,
      aktualni_stav: null,
      total: 0,
      dodavatel: null,
      pouze_naskladnit: false,
      saving: false
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.fa_datum_vystaveni = parseInt(new Date().getTime() / 1000);
    this.load();
  },
  watch: {
    produkty: {
      handler (v) {
        this.resolve();
      },
      deep: true
    },
    objednavka: {
      handler (v) {
        this.computeTotal();
      },
      deep: true
    }
  },
  props: {
    id: String
  },
  methods: {
    load: function() {
      window.API.get("dodavatele/objednavky/" + this.$props.id + "/faktura").then(function(b) {
        this.objednavka = b.objednavka;
        this.faktura = b.faktura;
        this.dodavatel = b.dodavatel;
        this.pouze_naskladnit = b.pouze_naskladnit;
        this.mena = b.mena;
        this.mena_id = b.mena.id;
        if (b.faktura != null) {
          this.mena_id = this.faktura.mena_id;
          this.fa_cislo = this.faktura.dodavatel_fa_cislo;
          this.fa_datum_vystaveni = this.faktura.dodavatel_fa_vystaveni;
          this.cena_dopravy = this.faktura.doprava_cena;
        }
        this.computeTotal();
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    changeMJ ($v) {
      $v.cena_celkem = $v.cena_mj != null && $v.cena_mj > 0 && $v.mnozstvi > 0 ? ($v.cena_mj * $v.mnozstvi).toFixed(2) : 0;
    },
    changeCelk ($v) {
      $v.cena_mj = $v.cena_celkem != null && $v.cena_celkem > 0 && $v.mnozstvi > 0 ? ($v.cena_celkem / $v.mnozstvi).toFixed(2) : 0;
    },
    ulozitFakturu () {
      if (this.saving)
        return;
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.dialog = true;
        this.aktualni_stav = "Ukládám fakturu";
        this.problem = null;
        window.API.put("dodavatele/objednavky/" + this.$props.id + "/faktura", {
          mena_id: this.mena_id,
          fa_cislo: this.fa_cislo,
          fa_datum_vystaveni: this.fa_datum_vystaveni,
          produkty: this.objednavka.produkty,
          cena_dopravy: this.cena_dopravy
        }).then((b) => {
          if (b.success) {
            this.dialog = false;
            this.e1 = 2;
            this.$router.push({ path: '/dodavatele/objednavky' });
          }
          else {
            this.problem = "Faktura nemohla být uložena.";
          }
          this.saving = false;
        }).catch((e) => {
          this.problem = "Faktura nemohla být uložena.";
          console.log(e);
          this.saving = false;
        })
      }
    },
    computeTotal () {
      var $total = 0;
      this.objednavka.produkty.forEach((e) => {
        if (e.cena_celkem != null && e.cena_celkem.toString().length > 0 && parseFloat(e.cena_celkem) >= 0)
          $total += parseFloat(e.cena_celkem);
      });
      this.total = $total;
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dodavatele/DodavateleObjednavkaFaktura.vue